<script>
	import { onMount } from 'svelte'
	import { tweened } from 'svelte/motion';
	import { linear } from 'svelte/easing';

	const rotation = tweened(0, {
		duration: 100,
		easing: linear
	});
	
	let hovering = false
	
	function enter() {
		hovering = true;
	}

	function leave() {
		hovering = false;
	}
	function handleClick() {
		// this is equivalent to size.update(n => n + 1)
		$rotation += 180;
	}
	
	function flip(){
		if(noFlip == true)
			return

		if($rotation < 180)
			$rotation += 180;
		else
			$rotation -= 180;
	}
	
	const patterns = {
  D: '♦',
  C: '♣',
  H: '♥',
  S: '♠' 
}

	export let suit = "D"
	export let rank = "A"
	export let size = ""
	export let disabled = false
	export let noFlip = false

	$: {
		suit = Object.hasOwn(patterns, suit) ? suit : "D"
	}
	/*
	onMount(() =>{
		let h = setInterval(() =>{
		//	$rotation+= 12
		}, 30)
		return () => {
			clearInterval(h)
		}
	})
	*/
</script>

<div class="card {suit} {size} bg-cross" class:disabled on:click={flip} on:mouseenter={enter} on:mouseleave={leave}>
	<div class="front" style="transform: rotateY({$rotation}deg);">
		{rank} <span class="suit">{patterns[suit]}</span>
	</div>
	<div class="back"  style="transform: rotateY({$rotation-180}deg);"></div>
</div>


<style>
	
	@import url("https://fonts.googleapis.com/css?family=ZCOOL+QingKe+HuangYou");
	.card {
			display: inline-block;
			position: relative;
			width: 72px;
			height: 92px;
			margin-inline: 8px;
			border-radius: 4px;
	}

	.card.disabled {
		opacity: 0.6;

	}

    .card.mini {
       /* font-size: 1em;*/
        padding-top: 0.1em;
        width: 44px;
        height: 34px;
        margin: 4px;
        line-height: 1.2em;
    }

    .card.small {
       /* font-size: 1em;*/
        padding-top: 0.1em;
        width: 48px;
        height: 56px;
        margin: 0.1em 0.4em;
        line-height: 1.1em;
    }
    .card.large {
       /* font-size: 1em;*/
        padding-top: 0.1em;
        width: 92px;
        height: 128px;
        margin: 0.4em 0.4em;
        line-height: 2em;
    }

	.card:hover {
		translate: -2px -3px;
		transition: 0.2s;
	}
	
	.card:hover > .front, .card:hover > .back {
		box-shadow: 6px 6px 7px 0px rgba(0, 0, 0, 0.15), 0px 0px 4px 1px rgba(232, 235, 205, 0.3);
	}
	
	.back {
		 border-radius: 6px;
	}
	.front {
		user-select: none;
		font-family: system-ui,"ZCOOL QingKe HuangYou", cursive;
		width:  -webkit-fill-available;
		height: -webkit-fill-available;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px outset #eee;
		border-radius: 6px;
		text-align: left;
		text-indent: 0.05em;
		padding: 8px;
		font-size: 1.4em;
		background-color: #FAFAFA;
		backface-visibility: hidden;
		box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.35);
	}

	.suit {
		font-family: system-ui, cursive;
		font-size: 1.1em;
	}
	
    .card.mini .front {
        font-size: 1em;
		padding: 2px;
    }
	
    .card.small .front {
        font-size: 1.25em;
		padding: 3px;
    }
    .card.large .front {
        font-size: 2em;
		padding: 8px;
    }

	.card.D {
		color: #ea3e13;
	}
	.card.H {
		color: #ea3e13;
	}
	.card.C {
		color: #1E1B19;
	}
	.card.S {
		color: #1E1B19;
	}
		
	.back {
		width:  -webkit-fill-available;
		height: -webkit-fill-available;
		position: absolute;
		top: 0;
		left: 0;
		border: 2px solid #eee;
		border-radius: 6px;
		background-color: #131354;
		opacity: 1;
		box-shadow: 6px 6px 7px 0px rgba(0, 0, 0, 0.35);
		
		background: radial-gradient(circle, transparent 20%, #131354 20%, #131354 80%, transparent 80%, transparent), radial-gradient(circle, transparent 20%, #131354 20%, #131354 80%, transparent 80%, transparent) 25px 25px, linear-gradient(#deadff 2px, transparent 2px) 0 -1px, linear-gradient(90deg, #deadff 2px, #131354 2px) -1px 0;
		background-size: 50px 50px, 50px 50px, 25px 25px, 25px 25px;
				backface-visibility: hidden;
	}
</style>